import { TooltipProps, Tooltip, tooltipClasses, styled } from "@mui/material";

export type IBootstrapTooltip = {
  children: React.JSX.Element;
  title: string;
  arrow: boolean;
  placement?: "top" | "left" | "right" | "bottom";
  color?: "secondary" | "primary" | "warning" | "success" | "error";
};

export const CustomToolTip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme, color = "primary" }) => {
  const colorValue =
    color === "primary"
      ? theme.palette.primary.main
      : color === "secondary"
        ? theme.palette.secondary.main
        : color === "error"
          ? theme.palette.error.main
          : color === "warning"
            ? theme.palette.warning.main
            : color === "success"
              ? theme.palette.success.main
              : theme.palette.primary.main;

  return {
    zIndex: 9999999,
    [`& .${tooltipClasses.arrow}`]: {
      color: colorValue,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      padding: 10,
      backgroundColor: colorValue,
    },
  };
});

const BootstrapTooltip = (
  props: Readonly<IBootstrapTooltip>,
): React.JSX.Element => {
  return (
    <CustomToolTip
      color={props.color}
      placement={props.placement}
      title={props.title}
      arrow
    >
      <span>{props.children}</span>
    </CustomToolTip>
  );
};

export default BootstrapTooltip;
